import { render } from "./party-multiselect.vue?vue&type=template&id=8960c790&scoped=true&ts=true"
import script from "./party-multiselect.vue?vue&type=script&lang=ts"
export * from "./party-multiselect.vue?vue&type=script&lang=ts"

import "./party-multiselect.vue?vue&type=style&index=0&id=8960c790&scoped=true&lang=css"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8960c790"]])

export default __exports__